import { render } from "./ClaimTypeAvailabilityLabel.vue?vue&type=template&id=71041ab3"
import script from "./ClaimTypeAvailabilityLabel.vue?vue&type=script&lang=js"
export * from "./ClaimTypeAvailabilityLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__